import React from "react";
import UploadImagesSVG from "./upload-images.svg";
import { Row, Col, Typography, Upload, Image, Button } from "antd";
import "./styles.css";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";

export default function UploadImages({
  showModal,
  photoList,
  handlePreview,
  uploadImage,
  beforeUpload,
  handleChangeUpload,
  onRemove,
}) {
  const renderPhotoTag = (tagName) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <span
          className="main-btn"
          style={{
            borderRadius: 0,
            padding: 8,
            borderRadius: 40,
            fontSize: 11,
            position: "absolute",
            bottom: 0,
            background: "white",
            margin: "0.7rem",
          }}
        >
          {tagName}
        </span>
      </div>
    );
  };

  const photoGallery = (length) => {
    const photo = {
      1: photoList.map((item, index) => (
        <Row key={index}>
          <Col>
            <div style={{ padding: "0.2rem" }}>
              <Image
                onClick={() => {
                  showModal()
                  gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.UPLOAD_IMAGE_PREVIEW);
                }}
                preview={false}
                height={"100%"}
                width={"100%"}
                style={{ borderRadius: 8, cursor: "pointer" }}
                alt="prodcuts"
                src={`${process.env.REACT_APP_DIRECTUS}assets/${item?.directus_files_id}?transforms=[["resize",{"width":600,"height":600,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
              />
            </div>
          </Col>
        </Row>
      )),
      2: (
        <Row>
          {photoList.map((item, index) => (
            <Col span={12} key={index}>
              <div style={{ padding: "0.2rem" }}>
                <Image
                  onClick={() => {
                    showModal()
                    gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.UPLOAD_IMAGE_PREVIEW);
                  }}
                  preview={false}
                  height={"100%"}
                  width={"100%"}
                  style={{ borderRadius: 8, cursor: "pointer" }}
                  alt="prodcuts"
                  src={`${process.env.REACT_APP_DIRECTUS}assets/${item?.directus_files_id}?transforms=[["resize",{"width":600,"height":600,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
                />
                {index === 0 && renderPhotoTag("Main Photo")}
                {index === 1 && renderPhotoTag("Secondary Photo")}
              </div>
            </Col>
          ))}
        </Row>
      ),
    };
    return (
      photo[length] || (
        <Row>
          {" "}
          {photoList.map((item, index) =>
            index < 4 ? (
              <Col span={12} key={index}>
                <div style={{ padding: "0.2rem" }}>
                  <Image
                    preview={false}
                    onClick={() => {
                      showModal()
                      gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.UPLOAD_IMAGE_PREVIEW);
                    }}
                    height={"100%"}
                    width={"100%"}
                    style={{ borderRadius: 8, cursor: "pointer" }}
                    alt="prodcuts"
                    src={`${process.env.REACT_APP_DIRECTUS}assets/${item?.directus_files_id}?transforms=[["resize",{"width":280,"height":180,"fit":"contain","background":{"r":242,"g":242,"b":242}}]]`}
                  />
                  {index === 0 && renderPhotoTag("Main Photo")}
                  {index === 1 && renderPhotoTag("Secondary Photo")}

                  {index === 3 && photoList?.length > 4 && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <span
                        style={{
                          bottom: 0,
                          position: "absolute",
                          fontSize: 14,
                          background: "rgb(0,0,0,0.7)",
                          color: "white",
                          padding: "0.5rem",
                          borderRadius: "0.5rem",
                          margin: "1rem",
                        }}
                      >
                        + {photoList?.length - 4} More
                      </span>
                    </div>
                  )}
                </div>
              </Col>
            ) : null
          )}
        </Row>
      )
    );
  };
  return (
    <>
      <Row
        align="middle"
        justify="center"
        style={{
          border: "1px dashed #CDCFCE",
          borderRadius: 8,
        }}
        className="left-photobox"
      >
        {photoList.length > 0 ? (
          <Row>{photoGallery(photoList.length)}</Row>
        ) : (
          <Upload
            onPreview={handlePreview}
            customRequest={uploadImage}
            beforeUpload={beforeUpload}
            onChange={handleChangeUpload}
            onRemove={onRemove}
            showUploadList={false}
            multiple
            onClick={() => {
              gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.UPLOAD_IMAGE_CONTAINER)
            }}
          >
            <ImageContainer />
          </Upload>
        )}
      </Row>

      <Row justify="space-between" style={{ marginTop: 20 }}>
        <Col>
          {photoList?.length > 0 && (
            <Upload
              onPreview={handlePreview}
              customRequest={uploadImage}
              beforeUpload={beforeUpload}
              onChange={handleChangeUpload}
              onRemove={onRemove}
              showUploadList={false}
               multiple
              onClick={() => {
                gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.UPLOAD_IMAGE_CONTAINER)
              }}
            >
              <Button style={{ width: "100%", height: 40 }} size="large"
                onClick={() => {
                  gaEvent(GA.EVENT.CLICK, GA.CATEGORY.ADD_PRODUCT, GA.DESCRIPTION.UPLOAD_IMAGE_MORE_BUTTON)
                }}
              >
                Upload more images
              </Button>
            </Upload>
          )}
        </Col>
      </Row>
    </>
  );
}

function ImageContainer() {
  return (
    <div style={{ cursor: "pointer" }}>
      <Col>
        <Row justify="center" style={{ height: "100%" }}>
          <Col>
            <img src={UploadImagesSVG} alt="Upload Images SVG" />
          </Col>
        </Row>
        <Row justify="center" style={{ height: "100%", marginTop: "1rem" }}>
          <Col>
            <Typography type="title">Upload Images</Typography>
          </Col>
        </Row>

        <Row justify="center" style={{ height: "100%" }}>
          <Col>
            <Typography.Text type="secondary">
              (Accepted formats png,jpeg)
            </Typography.Text>
          </Col>
        </Row>
      </Col>
    </div>
  );
}
